
import {
    useRecordContext,
    useNotify, useDataProvider, useRefresh,
    Button,
} from 'react-admin';
import Backdrop from '@mui/material/Backdrop';
import CircularProgress from '@mui/material/CircularProgress';
import { useState } from 'react';
import { Alert } from "@mui/material";
import SettingsInputAntennaIcon from '@mui/icons-material/SettingsInputAntenna';

const DeployButton = () => {
    const record = useRecordContext();
    const refresh = useRefresh();
    const notify = useNotify();
    const [isDisabled, setIsDisabled] = useState(false);
    const dataProvider = useDataProvider();
    const Handleclick = async () => {
        if (record.room_id) {
            const response = await dataProvider.getOne('rlab/room', { id: record.room_id });
            console.log("show record", response);
            const usedRoom = response.data.training ? true : false;
            if (usedRoom) {
                const confirmed = window.confirm(`Classroom {${response.data.name}} is already in use \r\nAre you sure you want to continue?`);
                if (!confirmed) {
                    return;
                }
            }
        }
        setIsDisabled(true);
        dataProvider.showOne(`task/training/deploy/${record.id}`)
            .then(({ data }) => {
                if (data) {
                    notify(
                        <Alert severity="success">
                            Training has been deployed successfully.
                        </Alert>
                    );
                } else {
                    notify(
                        <Alert severity="error">
                            Something went wrong, please try again later.
                        </Alert>
                    );
                }
            })
            .catch((error) => {
                // Determine the error message to display
                let errorMessage = error.message || 'An error occurred, please try again later.';

                // If backend returned a message
                if (error.body?.message) {
                    errorMessage = error.body.message;
                } else if (error.response?.data?.message) {
                    errorMessage = error.response.data.message;
                } else if (error.message) {
                    errorMessage = error.message;
                }

                notify(
                    <Alert severity="error">
                        {errorMessage}
                    </Alert>
                );
            })
            .finally(() => {
                setIsDisabled(false);
                refresh();
            });
    };

    return (
        <div>
            <Button startIcon={<SettingsInputAntennaIcon />} label="Deploy" onClick={() => Handleclick()} disabled={isDisabled} />
            <Backdrop
                sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
                open={isDisabled}
            >
                <CircularProgress color="secondary" />
            </Backdrop>
        </div>
    )
}
export default DeployButton;
